import { render, staticRenderFns } from "./CopyrightAmendmentPopupDetails.vue?vue&type=template&id=7c8f541e&scoped=true&"
import script from "./CopyrightAmendmentPopupDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentPopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentPopupDetails.vue?vue&type=style&index=0&id=7c8f541e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f541e",
  null
  
)

export default component.exports